import React from 'react';
import './AdminHero.css';

const AdminHero = () => {
  return (
    <section className="admin-hero">
      <div className="admin-hero-overlay">
        <div className="admin-hero-content">
          <h1>Department of Administration</h1>
          <p>Driving internal coordination, communication, and council operations in Igbo-Eze North.</p>
        </div>
      </div>
    </section>
  );
};

export default AdminHero;